import { Assets } from "@/utils/assets";
import { Global } from "@/utils/global";
import { Scenes } from "@/utils/scenes";
import Phaser from "phaser";

class Preload extends Phaser.Scene{

    constructor(){
        super({
            key: Scenes.Preload
        });
    }

    //Phaser scene functions
    public init():void{
        /* Init function */

        this.sceneevent();

    }

    public preload():void{
        /* Preload function */

        /* Preload images */
        this.load.path = '/assets/image/'
        this.load.image(Assets.BG1.ID,Assets.BG1.FILENAME);
        this.load.image(Assets.BG2.ID,Assets.BG2.FILENAME);
        this.load.image(Assets.BG3.ID,Assets.BG3.FILENAME);
        this.load.image(Assets.BG4.ID,Assets.BG4.FILENAME);
        this.load.image(Assets.BG5.ID,Assets.BG5.FILENAME);

        this.load.path = '/assets/sprite/'
        this.load.atlas(Assets.GAME.ID,Assets.GAME.FILENAME,Assets.GAME.JSON);

        this.load.path = '/assets/font/'
        this.load.bitmapFont(Assets.FONT1.ID,Assets.FONT1.FILENAME,Assets.FONT1.XML);

        this.load.path = '/assets/sound/'
        this.load.audio(Assets.BGMUSIC.ID,Assets.BGMUSIC.FILENAME);
        //this.load.audio(Assets.SHOOTSFX.ID,Assets.SHOOTSFX.FILENAME);
        //this.load.audio(Assets.LOSTSFX.ID,Assets.LOSTSFX.FILENAME);

    }

    public create():void{

        /* Create function */
        window.enablePlay(true);
        
        //this.movetogame();

    }

    public update():void{
        /* Update function */
    }

    //Other functions
    private movetogame(): void{

        this.scene.stop();
        this.scene.start(Scenes.Game);

    }

    private showintro(): void{

        //window.showOrHideIntro(true);
        //this.movetogame();

    }


    //Scene Events
    private sceneclear(): void{
        /* Scene Clear */
    }

    private scenepause(): void{
        /* Scene Pause */
    }

    private sceneresume(): void{
        /* Scene Resume */
    }

    private sceneevent(): void{

        this.events.on(Phaser.Scenes.Events.SHUTDOWN, ()=>{
            this.sceneclear();
        });

        this.events.on(Phaser.Scenes.Events.PAUSE, ()=>{
            this.scenepause();
        });

        this.events.on(Phaser.Scenes.Events.RESUME, ()=>{
            this.sceneresume();
        });

    }

}

export { Preload }
